'use client';

import { Menu } from '@mui/material';

import { styled } from '../../styles';
import { getDropdownMaxHeight } from '../../utils';

import { MenuProps } from './types';

export const StyledMenu = styled(Menu)<MenuProps>(({ size, theme }) => ({
  maxHeight: getDropdownMaxHeight(size),

  '.MuiPaper-root': {
    backgroundColor: theme.palette.surface2,
  },
}));
